import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { Checkbox } from './ui/checkbox';

export const SMS_CONSENT_TEXT =
  'I agree to receive SMS messages from A Quality Handyman regarding estimates, appointments, scheduling, job updates, payments, and customer service. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. Consent is not a condition of purchase.';

// Optional, unchecked-by-default, never required. Used on every public form that collects a phone number.
export const SmsConsentCheckbox = ({ id = 'sms-consent', checked = false, onCheckedChange, testId = 'sms-consent-checkbox', className = '' }) => (
  <div className={`rounded-lg border border-slate-200 bg-slate-50/80 p-3 text-left ${className}`} data-testid={`${testId}-wrap`}>
    <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500 mb-2">
      <MessageSquare className="w-3.5 h-3.5 text-brand-teal" /> Text message updates (optional)
    </p>
    <div className="flex items-start gap-3">
      <Checkbox
        id={id}
        checked={!!checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="mt-0.5 h-5 w-5 border-slate-400 bg-white data-[state=checked]:bg-brand-teal data-[state=checked]:border-brand-teal"
        data-testid={testId}
        aria-describedby={`${id}-links`}
      />
      <label htmlFor={id} className="text-xs leading-relaxed text-slate-600 cursor-pointer select-none" data-testid={`${testId}-label`}>
        {SMS_CONSENT_TEXT}
      </label>
    </div>
    <p id={`${id}-links`} className="mt-2 pl-8 text-xs text-slate-500" data-testid={`${testId}-links`}>
      <Link to="/privacy" className="text-brand-blue underline underline-offset-2 hover:text-brand-teal">Privacy Policy</Link>
      <span className="mx-1.5">·</span>
      <Link to="/terms" className="text-brand-blue underline underline-offset-2 hover:text-brand-teal">Terms &amp; Conditions</Link>
      <span className="mx-1.5">·</span>
      <Link to="/sms-terms" className="text-brand-blue underline underline-offset-2 hover:text-brand-teal">SMS Terms</Link>
    </p>
  </div>
);

export default SmsConsentCheckbox;
